import PropTypes from 'prop-types';
import React from 'react';
import styles from './MainWrapper.module.scss';
import BackButton from './BackButton';

function MainWrapper({
  children, className, caption, path, onClick,
}) {
  return (
    <div className={styles.marginsContainer}>
      <div className={styles.margin} />
      <div className={className || styles.contentWrapper}>
        {
          caption
            && (
              <BackButton
                caption={caption}
                path={path}
                onClick={onClick}
              />
            )
        }
        {children}
      </div>
      <div className={styles.margin} />
    </div>
  );
}

MainWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  caption: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  path: PropTypes.instanceOf(Array),
};

MainWrapper.defaultProps = {
  onClick: () => {},
  caption: '',
  className: '',
  path: [],
};

export default MainWrapper;
